import Tab from 'semantic-ui-react/dist/commonjs/modules/Tab';
import '@purple/semantic-ui-purple-theme/components/tab.css';

export default Tab;
